import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import {
	createStyles,
	StyledComponentProps,
	withStyles,
} from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import ListIcon from '@material-ui/icons/List';
import classnames from 'classnames';
import * as React from 'react';
import ReactTable, {
	ReactTableDefaults,
	RowInfo,
	RowRenderProps,
	TableProps,
} from 'react-table';
import 'react-table/react-table.css';
import i18n from '../resources/i18n';

ReactTableDefaults.ThComponent = ({
	toggleSort,
	className,
	children,
	...rest
}) => (
	// eslint-disable-next-line jsx-a11y/click-events-have-key-events
	<div
		className={classnames('rt-th', className)}
		// tslint:disable-next-line:jsx-no-lambda
		onClick={e => toggleSort && toggleSort(e)}
		role="columnheader"
		{...rest}
	>
		{children}
	</div>
);

const userAgent = window.navigator.userAgent.toLowerCase();
if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1) {
	// IEのときのみ下記スタイルを追加
	const sheet = document.styleSheets[0] as any;
	sheet.insertRule(
		'div.rt-table{display: block !important;}',
		sheet.cssRules.length
	);
}

const styles = (theme: Theme) => {
	if (theme.extends && theme.extends.MuiReactTable) {
		return createStyles({
			table: { ...theme.extends.MuiReactTable.root },
		});
	}

	return createStyles({
		table: {},
	});
};

interface IMyTableProps {
	indicator?: string;
	columnsMenu?: boolean;
	menuHandler?: (event: React.MouseEvent<HTMLElement>) => void;
	heightStyle?: string;
}

/**
 * 共通テーブルコンポーネント
 */
const MyReactTable = withStyles(styles)(
	(
		myProps: Partial<TableProps> &
			StyledComponentProps<'table'> &
			IMyTableProps
	) => {
		const tableProps = { ...myProps };
		tableProps.previousText =
			tableProps.previousText || i18n.t('MyReactTable_0001');
		tableProps.nextText =
			tableProps.nextText || i18n.t('MyReactTable_0002');
		tableProps.pageText = tableProps.pageText || '';
		tableProps.ofText = tableProps.ofText || '/';
		tableProps.rowsText =
			tableProps.rowsText || i18n.t('MyReactTable_0003');
		tableProps.noDataText =
			tableProps.noDataText || i18n.t('MyReactTable_0004');
		tableProps.className = tableProps.className || '';
		if (myProps.classes !== void 0 && myProps.classes.table !== void 0) {
			tableProps.className += ' ' + myProps.classes.table;
		}

		const { columnsMenu, indicator, menuHandler, heightStyle } = myProps;
		let topGrid: JSX.Element | null = null;
		if (columnsMenu || indicator) {
			topGrid = (
				<Grid container={true} alignItems={'flex-end'}>
					<Grid item={true} style={{ flex: 1 }}>
						<Typography variant="caption" gutterBottom={true}>
							{indicator ? indicator : ''}
						</Typography>
					</Grid>
					<Grid item={true}>
						{columnsMenu && (
							<>
								<IconButton size="small" onClick={menuHandler}>
									<ListIcon />
								</IconButton>
								<Typography
									variant="caption"
									align="center"
									style={{ marginTop: -10 }}
									display="block"
								>
									{i18n.t('MyReactTable_0005')}
								</Typography>
							</>
						)}
					</Grid>
				</Grid>
			);
		}

		return (
			<>
				{topGrid}
				<ReactTable {...tableProps} style={{ height: heightStyle }} />
			</>
		);
	}
);

export default MyReactTable;
export type RowInfo = RowInfo;
export type RowRenderProps = RowRenderProps;
export type TableProps = TableProps & IMyTableProps;



// WEBPACK FOOTER //
// ./src/components/MyReactTable.tsx